import React, { useState, useEffect } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Badge } from 'reactstrap';
import DeleteModal from "../DeleteModal" 
import { SuccessOk } from 'configs/statusCode';
import { toast } from 'react-toastify';
import { useSelector } from "react-redux"

const CardItem = ({ index, item, id, Service, name, status, getList ,updateHandler ,viewHandler}) => {
    const [deleteModal, setDeleteModal] = useState(false);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [itemStatus, setItemStatus] = useState(false);
    const AuthData = useSelector(state => state.Auth)
    const isExist = (data) => (AuthData.permissions.includes(data) || AuthData.email === "admin@meras.com")
    const service = new Service
    const toggle = () => setDropdownOpen(prevState => !prevState);

    const handleCloseModal = (action, response) => {
        setDeleteModal(false);
        if (action === "delete") {
            getList()
        }
    };
    useEffect(() => {
        setItemStatus(status)
    }, [status])
    const changeStatus = (e) => {
        const value = e.target.checked
        service.toggleActivation(item.developer_id, {
            status: !itemStatus,
         }).then((res) => {
            if (res && res.status === SuccessOk) {
                setItemStatus(value)
                toast.success(res.data.success);
                setTimeout(() => {
                    getList()
                }, 1000);
            }
        });
    }
 
    return (
        <>
            <tr key={index}>
                <td className='font-size-16'>{item.developer_id}</td>
                <td className='font-size-16 text-decoration-underline' style={{fontWeight:"bold"}}>{item.name}</td>
                <td className='font-size-16'>{(Number.isInteger(item.rate/item.count))?((item.rate/item.count)):((item.rate/item.count).toFixed(2))} %</td>
                <td className='font-size-16'>
                    {item?.areas.filter((obj, index, arr) => {
                        return index === arr.findIndex((o) => o.id === obj.id);
                        })?.map((area, index)=> {
                        return (
                            <>
                            <Badge className="bgBadge font-size-14 mt-0 m-1" key={index} 
                                style={{ background: "#50a5f1", color:"#556EE6", marginTop: "0px !important" }}>{area?.name?.en}
                            </Badge>
                            {index == 4 && <br /> } {index == 8 && <br /> }
                            </>
                        )
                    })}
                </td>

                <td className='font-size-14 py-0'>
                    <form>
                        <div className='form-check form-switch form-switch-md mb-1'>
                            <input
                                name='status'
                                checked={itemStatus}
                                type='checkbox'
                                className='form-check-input'
                                id='has_status'
                                onChange={changeStatus}
                                disabled={isExist("rate.edit") ? false:true}

                            />
                        </div>
                    </form>
                </td>
                 <td className="removebtnhover">
                <Dropdown color="light" className="dropdownWidth" isOpen={dropdownOpen} toggle={toggle}>
                    <DropdownToggle caret>
                        <i className="fa fa-ellipsis-v text-dark fa-lg"></i>
                    </DropdownToggle>
                    <DropdownMenu>
                    <DropdownItem onClick={() => {
                            viewHandler()
                        }}>View</DropdownItem>
                      {isExist("rate.edit") ?  <DropdownItem onClick={() => {
                            updateHandler()
                        }}>Edit</DropdownItem>:null}
                        {isExist("rate.delete") ? <DropdownItem className="text-danger" onClick={() => {
                            setDeleteModal(!deleteModal);
                        }}>Remove Rate</DropdownItem> :null}
                    </DropdownMenu>
                </Dropdown> </td>
            </tr>
            <DeleteModal
                open={deleteModal}
                titleMsg={item?.name}
                deletedItem={item}
                modelService={service}
                onCloseModal={(action) => handleCloseModal(action)}
            />
        </>

    );
}

export default CardItem;